export const quotaI18nKeys = {
  dataCreditsLeft: 'quota.data-credits.left',

  total: 'quota.badge.total',

  notifyAdmin: 'quota.low_credits.user.notify-admin',
  notifyAdminText: 'quota.low_credits.user.notify-admin.text',
  notifyAdminSuccessTitle: 'quota.notify_admin.success.title',
  notifyAdminSuccessDescription: 'quota.notify_admin.success.description',

  manageCredits: 'quota.low_credits.admin.manage-credits',
  manageCreditsText: 'quota.low_credits.admin.manage-credits.text',

  lowCreditsTitle: 'quota.low_credits.title',

  needMoreCreditsTitle: 'quota.need_credits.title',
  needMoreCreditsDescription: 'quota.need_credits.description',
} as const;
